module.exports = __webpack_public_path__ + "img/cross-white-small.6038fcf6.svg";